export type EsgPaiApi = {
  values: {
    esg_biodiversity_value: { exposure: boolean }
    esg_gender_equality_value: { exposure: boolean }
    esg_greenhouse_gases_value: { exposure: boolean }
    esg_hazardous_waste_value: { exposure: boolean }
    esg_human_rights_value: { exposure: boolean }
    esg_water_pollution_value: { exposure: boolean }
  }
}

export const ESG_PREFERENCES_API = {
  GENERIC: 'generic',
  CUSTOM: 'custom',
  NEUTRAL: 'none',
  NONE: '',
} as const

export type EsgPreferenceApi = ValueOf<typeof ESG_PREFERENCES_API>

export const ESG_LABELS_API = {
  NEUTRAL: 'Neutre',
  INVOLVED: 'Impliqué',
  RESPONSIBLE: 'Responsable',
  COMMITTED: 'Engagé',
  NONE: '',
} as const

export type EsgLabelApi = ValueOf<typeof ESG_LABELS_API>

export type EsgExtra = {
  preference?: EsgPreferenceApi
  criteria: unknown[]
}
